// https://api.zerek.edus.kz/
// http://192.168.31.137:8000/

module.exports = {
  API_URL: "https://api.zerek.edus.kz/",
  API_VERSION: "v1",
  LANDING_URL: "https://zerek.edus.kz/login",
  GOS_ZEREK_URL: "https://gos.zerek.edus.kz/#/login"
};
